import React from 'react';
import { ListItem, ListItemText, MenuItem, Menu } from '@material-ui/core';
import { connect } from 'react-redux';
import * as DevToolActions from 'app/actions/dev-tool/actions';
import { CitizenshipType } from 'app/models/options/enums';
import { LivingSituation, MilitaryExperienceType } from '@lenderful/domain';

const nancy: any = {
  isTestCase: true,
  assets: [
    {
      accountType: 'CH',
      accountBalance: 5800,
    },
    {
      accountType: 'SA',
      accountBalance: 22002,
    },
  ],
  hasCoBorrowerOnTitle: 'Yes',
  loanAmount: 65000,
  numberOfDependents: '2',
  livingRentOrOwn: LivingSituation.OWN,
  livingPropertyType: 'SFH',
  livingPropertyStreet: '1234 S Main St',
  livingPropertyCity: 'Royal Oak',
  livingPropertyState: 'MI',
  livingPropertyZip: '48067',
  livingOccupancyStart: '01-01-2006',
  decBorrower: {
    ethnicity: [
      '2',
    ],
    race: [
      'Black or African American',
    ],
    sex: [
      'F',
    ],
    hasCitizenship: true,
    hasJudgements: true,
    hasBankrupt: true,
    bankruptType: 'SEVEN',
    bankruptAge: '3',
    hasForeclosed: false,
    hasBorrowedDown: true,
    borrowedDownAmount: 25000,
    hasDelinquent: true,
    hasLawsuit: true,
    hasOccupyPrimary: true,
    hasOwnerInterest: true,
    ownerPropertyUsage: 'INV',
    ownerTitleHeld: 'JO',
    scheduleDate: 'Monday',
    scheduleTime: '12pm',
  },
  decCoBorrower: {
    ethnicity: [
      'NO_SHARE',
    ],
    race: [
      'American Indian or Alaska Native',
      'Asian',
      'Black or African American',
      'Native Hawaiian or Other Pacific Islander',
    ],
    sex: [
      'F',
      'M',
    ],
    hasCitizenship: false,
    hasGreenCard: true,
    raceAsian: [
      'CHINESE',
      'JAPANESE',
    ],
    raceIslander: [
      'GUAMANIAN_OR_CHAMORRO',
      'SAMOAN',
    ],
  },
  email: 'lenderful@lenderful.com',
  escrowUsage: 'Yes',
  annualTaxes: 3600,
  annualInsurance: 1200,
  annualAssociation: 600,
  fico: '739',
  firstName: 'Nancy',
  lastName: 'Pericevich',
  loanPurpose: 'CASHOUT',
  phone: '(313) 567-8900',
  propertyType: 'CON',
  propertyUsage: '2ND',
  propertyZip: '48222',
  schedulerEnabled: false,
  propertyAppraisedValue: 245000,
  insertId: 697,
  rate: 3.375,
  fee: 2895,
  apr: 3.395,
  loanTerm: 15,
  loanType: 'CONVENTIONAL',
  productType: 'FIXED',
  monthlyPayment: 460.69,
  selectedRate: {
    apr: 3.395,
    loanAmount: 65000,
    pmiMonthlyPayment: 0,
    principalAndInterestPayment: 460.69,
    productFamily: 'CONVENTIONAL',
    productName: '15 Year Fixed Conventional',
    productType: 'FIXED',
    rate: 3.375,
    term: 15,
    quoteFees: 2895,
    loanType: '15 Year Fixed Conventional',
    applyUrl: '/v2/application/?rate=3.375&type=15%20Year%20Fixed%20Conventional&fees=2895',
  },
  middleName: 'C.',
  dateOfBirth: '08-21-1999',
  propertyStreet: '2299 Grapevine',
  propertyCity: 'Detroit',
  propertyState: 'MI',
  hasAdditionalProperties: 'Yes',
  additionalProperties: [
    {
      propertyType: 'SFH',
      propertyUsage: 'PRI',
      propertyStreet: '1234 Main St.',
      propertyCity: 'Holland',
      propertyState: 'MI',
      propertyZip: '49423',
      propertyValue: 150000,
      propertyAnnualTaxAmount: 4000,
      propertyAnnualInsuranceAmount: 1000,
      propertyAnnualAssociationAmount: 250,
    },
  ],
  married: 'Separated',
  citizenshipType: CitizenshipType.US_CITIZEN,
  militaryExperience: MilitaryExperienceType.NONE,
  hasCoBorrower: 'Yes',
  coBorrowerFirstName: 'Keith',
  coBorrowerLastName: 'Petricevich',
  coBorrowerDateOfBirth: '1954-03-11T05:00:00.000Z',
  coBorrowerEmail: 'lenderful@lenderful.com',
  coBorrowerPhone: '(555) 867-5309',
  coBorrowerSameAddress: 'Yes',
  coBorrowerMarried: 'Unmarried',
  coBorrowerCitizenshipType: CitizenshipType.US_CITIZEN,
  coBorrowerMilitaryExperience: MilitaryExperienceType.NONE,
  coBorrowerEmploymentType: 'RET',
  coBorrowerRetirementIncome: [
    {
      incomeSource: 'SS',
      incomeMonthly: 2500,
    },
  ],
  livingEscrowUsage: 'Yes',
  livingYearTaxes: 2400,
  livingYearInsure: 3600,
  livingYearAssociate: 4950,
  employmentType: 'EMP',
  employCompanyName: '3 Point Trucking Inc',
  employStreet: '14167 Lakeside Blvd N',
  employCity: ' Shelby Charter Twp',
  employZip: '48315',
  employState: 'MI',
  employTitle: 'Outside Sales',
  employPhone: '(555) 222-1234',
  employStart: '2020-02-02T05:00:00.000Z',
  employBase: 4500,
  employPartyTransaction: 'No',
  employPrevName: 'Elite Mold and Engineering, Inc.',
  employPrevStreet: '51548 Filomena Dr',
  employPrevZip: '48315',
  employPrevState: 'MI',
  employPrevCity: 'Shelby',
  employPrevStart: '2006-12-20T05:00:00.000Z',
  employPrevEnd: '2019-12-12T05:00:00.000Z',
  employCommission: 200,
  employBonus: 100,
  additionalIncome: [
    {
      incomeSource: 'AL',
      incomeMonthly: 450,
    },
    {
      incomeSource: 'RET',
      incomeMonthly: 890,
    },
  ],
};

const rusty: any = {
  isTestCase: true,
  assets: [
    {
      accountType: 'CH',
      accountBalance: 12312312,
    },
    {
      accountType: 'SP',
      accountBalance: 60500,
    },
    {
      accountType: 'SA',
      accountBalance: 1200,
    },
    {
      accountType: 'RE',
      accountBalance: 825,
    },
    {
      accountType: 'IN',
      accountBalance: 1122,
    },
    {
      accountType: 'IN',
      accountBalance: 2211,
    },
  ],
  downPaymentDollar: 180000,
  downPaymentPercent: 30,
  builtYear: '2015',
  hasCoBorrowerOnTitle: 'No',
  listingPrice: 0,
  loanPurpose: 'PURCHASE',
  mortgageBalance: 0,
  numberOfDependents: 0,
  citizenshipType: CitizenshipType.US_CITIZEN,
  militaryExperience: MilitaryExperienceType.NONE,
  decBorrower: {
    ethnicity: [
      'NO_SHARE',
    ],
    race: [
      'NO_SHARE',
    ],
    sex: [
      'NO_SHARE',
    ],
    hasCitizenship: true,
    scheduleDate: 'Any Day',
    scheduleTime: '11am',
    hasJudgements: false,
    hasBankrupt: false,
    hasAlimony: false,
    hasBorrowedDown: true,
    borrowedDownAmount: 25000,
    hasNoteEndorsement: true,
    hasOccupyPrimary: true,
    hasOwnerInterest: true,
    ownerPropertyUsage: 'PRI',
    ownerTitleHeld: 'S',
  },
  decCoBorrower: {
    ethnicity: [
      'NO_SHARE',
    ],
    race: [
      'NO_SHARE',
    ],
    sex: [
      'NO_SHARE',
    ],
    hasCitizenship: true,
  },
  annualTaxes: 111,
  annualInsurance: 222,
  annualAssociation: 3,
  schedulerEnabled: false,
  buyingProcess: 'Signed Purchase Agreement',
  email: 'lenderful@lenderful.com',
  escrowUsage: 'No',
  fico: '740',
  lastName: 'Bordein',
  phone: '(313) 555-1212',
  propertyType: 'SFH',
  propertyUsage: 'PRI',
  propertyZip: '48315',
  propertyAppraisedValue: 600000,
  firstName: 'Rusty',
  insertId: 1279,
  rate: 3.375,
  fee: -1377.6,
  apr: 3.386,
  loanTerm: 30,
  loanType: 'CONVENTIONAL',
  productType: 'FIXED',
  monthlyPayment: 1856.8,
  selectedRate: {
    apr: 3.386,
    loanAmount: 420000,
    pmiMonthlyPayment: 0,
    principalAndInterestPayment: 1856.8,
    productFamily: 'CONVENTIONAL',
    productName: '30 Year Fixed Conventional',
    productType: 'FIXED',
    rate: 3.375,
    term: 30,
    quoteFees: -1377.6,
    loanType: '30 Year Fixed Conventional',
    applyUrl: '/v2/application/?rate=3.375&type=30%20Year%20Fixed%20Conventional&fees=-1377.6',
  },
  middleName: 'T',
  homeChosen: 'Yes',
  dateOfBirth: '1985-02-02T05:00:00.000Z',
  purchaseAgreement: 'No',
  propertyStreet: '13136 Parkridge',
  propertyCity: 'Shelby Township',
  propertyState: 'MI',
  homeSold: 'No',
  married: 'Unmarried',
  hasCoBorrower: 'No',
  livingRentOrOwn: LivingSituation.OWN,
  livingPropertyType: 'SFH',
  livingPropertyStreet: '2211 Drake Ave.',
  livingPropertyCity: 'Grosse Pointe Woods',
  livingPropertyState: 'MI',
  livingPropertyZip: '48333',
  livingOccupancyStart: '02-02-2000',
  livingMonthlyMortgage: 2222,
  livingYearTaxes: 3333,
  livingYearInsure: 1,
  livingEscrowUsage: 'Yes',
  hasAdditionalProperties: 'Yes',
  employmentType: 'SE',
  retirementIncome: [],
  propertyStreet2: 'Suite #120',
  landingLoanType: 'PURCHASE',
  livingPropertyStreet2: '#9922',
  livingYearAssociate: 1200,
  additionalProperties: [
    {
      propertyType: 'SFH',
      propertyUsage: 'PRI',
      propertyStreet: '1234 Main St.',
      propertyCity: 'Holland',
      propertyState: 'MI',
      propertyZip: '49423',
      propertyValue: 150000,
      propertyAnnualTaxAmount: 4000,
      propertyAnnualInsuranceAmount: 1000,
      propertyAnnualAssociationAmount: 250,
    },
    {
      propertyType: 'CON',
      propertyUsage: 'INV',
      propertyAnnualRentAmount: 11000,
      propertyStreet: '2354 Madison Ave',
      propertyCity: 'Grand Rapids',
      propertyState: 'MI',
      propertyZip: '49507',
      propertyValue: 125000,
      propertyAnnualTaxAmount: 6000,
      propertyAnnualInsuranceAmount: 2000,
    },
    {
      propertyType: 'SFH',
      propertyUsage: 'INV',
      propertyStreet2: '',
      propertyCity: 'Kalamazoo',
      propertyState: 'MI',
      propertyValue: 75000,
      propertyAnnualInsuranceAmount: 600,
      propertyAnnualTaxAmount: 2400,
      propertyAnnualRentAmount: 12000,
      propertyStreet: '5678 E Main St',
      propertyZip: '49048',
    },
  ],
  employCompanyName: 'ABC Warehouse',
  employStreet: '900 Acre Avenue',
  employStreet2: 'Building 2',
  employCity: 'Dallas',
  employState: 'TX',
  employZip: '63823',
  employTitle: 'Investment Analyst',
  employPhone: '(555) 867-5309',
  employStart: '1995-12-10T05:00:00.000Z',
  employBase: 21000,
  employCommission: 20,
  employOwnershipShare: 'GT',
  employPartyTransaction: 'No',
  employBonus: 500,
  additionalIncome: [
    {
      incomeSource: 'CS',
      incomeMonthly: 250,
    },
    {
      incomeSource: 'CS',
      incomeMonthly: 300,
    },
  ],
};

const paul: any = {
  isTestCase: true,
  decBorrower: {
    ethnicity: [
      'NO_SHARE',
    ],
    race: [
      'NO_SHARE',
    ],
    sex: [
      'NO_SHARE',
    ],
    hasCitizenship: false,
    hasJudgements: true,
    hasBankrupt: true,
    hasForeclosed: true,
    hasLawsuit: true,
    hasLoanObligation: true,
    hasDelinquent: true,
    hasAlimony: false,
    hasBorrowedDown: true,
    borrowedDownAmount: 25000,
    hasNoteEndorsement: true,
    hasOccupyPrimary: true,
    hasGreenCard: true,
    bankruptType: 'SEVEN',
    bankruptAge: '7',
    forecloseCompleted: '2015-01-01T05:00:00.000Z',
  },
  decCoBorrower: {
    ethnicity: [
      '1',
    ],
    race: [
      'White',
    ],
    sex: [
      'M',
    ],
    hasCitizenship: false,
    hasJudgements: true,
    hasBankrupt: true,
    hasForeclosed: true,
    hasLawsuit: true,
    hasLoanObligation: true,
    hasDelinquent: true,
    hasAlimony: false,
    hasBorrowedDown: true,
    borrowedDownAmount: 25000,
    hasNoteEndorsement: true,
    hasOccupyPrimary: true,
    bankruptType: 'SEVEN',
    bankruptAge: '6',
    forecloseCompleted: '2014-12-12T05:00:00.000Z',
    hasGreenCard: true,
    ethnicityHispanic: [
      'MEXICAN',
    ],
  },
  livingRentOrOwn: LivingSituation.OWN,
  loanAmount: 99999,
  loanPurpose: 'HELOC',
  mortgageBalance: 215000,
  numberOfDependents: '2',
  citizenshipType: '01',
  propertyType: 'SFH',
  propertyUsage: 'PRI',
  schedulerEnabled: false,
  propertyAppraisedValue: 455000,
  propertyZip: '48124',
  maxLoanAmount: 150000,
  fico: '720',
  firstName: 'Paul',
  middleName: 'Ashford',
  lastName: 'Nabors',
  email: 'lenderful@lenderful.com',
  phone: '(313) 854-5522',
  insertId: 698,
  rate: 4.99,
  apr: 4.99,
  loanTerm: 25,
  loanType: 'HELOC',
  productType: 'ARM',
  monthlyPayment: 790,
  selectedRate: {
    loanType: '15 Year HELOC',
    term: 25,
    productName: 'HELOC 15',
    productFamily: 'HELOC',
    productType: 'ARM',
    rate: 4.99,
    apr: 4.99,
    principalAndInterestPayment: 790,
    pmiMonthlyPayment: 0,
    loanAmount: 100000,
  },
  homeEquityLoanPurpose: 'Home Improvement',
  dateOfBirth: '1988-05-05T04:00:00.000Z',
  hasCoBorrower: 'Yes',
  coBorrowerFirstName: 'Eleonora',
  coBorrowerMiddleName: 'Caroline',
  coBorrowerLastName: 'Anastasia',
  coBorrowerEmail: 'lenderful@lenderful.com',
  coBorrowerDateOfBirth: '06-08-2000',
  coBorrowerCitizenshipType: '01',
  married: 'Unmarried',
  propertyStreet: '17736 W 13 Mile Rd',
  propertyCity: 'Beverly Hills',
  propertyState: 'MI',
  minLoanMet: 'Yes',
  livingYearTaxes: 1244,
  livingYearInsure: 3212,
  livingYearAssociate: 250,
  hasAdditionalProperties: 'Yes',
  additionalProperties: [
    {
      propertyType: 'MOD',
      propertyUsage: 'INV',
      propertyAnnualRentAmount: 12000,
      propertyStreet: '1234 Main St.',
      propertyCity: 'Holland',
      propertyState: 'MI',
      propertyZip: '49423',
      propertyValue: 150000,
      propertyAnnualTaxAmount: 4000,
      propertyAnnualInsuranceAmount: 1000,
      propertyAnnualAssociationAmount: 250,
    },
    {
      propertyType: '24U',
      propertyUsage: 'INV',
      propertyAnnualRentAmount: 11000,
      propertyStreet: '2354 Madison Ave',
      propertyCity: 'Grand Rapids',
      propertyState: 'MI',
      propertyZip: '49507',
      propertyValue: 125000,
      propertyAnnualTaxAmount: 6000,
      propertyAnnualInsuranceAmount: 2000,
    },
    {
      propertyType: 'CON',
      propertyUsage: 'INV',
      propertyAnnualRentAmount: 16000,
      propertyStreet2: '',
      propertyCity: 'Kalamazoo',
      propertyState: 'MI',
      propertyValue: 75000,
      propertyAnnualInsuranceAmount: 600,
      propertyAnnualTaxAmount: 2400,
      propertyStreet: '5678 E Main St',
      propertyZip: '49048',
    },
    {
      propertyType: 'CON',
      propertyUsage: '2ND',
      propertyStreet2: '',
      propertyCity: 'Allegan',
      propertyState: 'MI',
      propertyValue: 125000,
      propertyAnnualInsuranceAmount: 600,
      propertyAnnualTaxAmount: 2400,
      propertyAnnualRentAmount: 12000,
      propertyStreet: '1234 N Main St',
      propertyZip: '49010',
    },
  ],
  employmentType: 'OTHER',
  otherIncome: [
    {
      incomeSource: 'SS',
      incomeMonthly: 220,
    },
    {
      incomeSource: 'CS',
      incomeMonthly: 290,
    },
    {
      incomeSource: 'AL',
      incomeMonthly: 222,
    },
    {
      incomeSource: 'MIL',
      incomeMonthly: 4300,
    },
  ],
  coBorrowerEmploymentType: 'NOT',
};

const benjamin: any = {
  isTestCase: true,
  decBorrower: {
    ethnicity: [
      'NO_SHARE',
    ],
    race: [
      'NO_SHARE',
    ],
    sex: [
      'NO_SHARE',
    ],
    hasCitizenship: true,
    hasJudgements: true,
    hasBankrupt: false,
    hasForeclosed: false,
    hasLawsuit: true,
    hasAlimony: false,
    hasNoteEndorsement: true,
  },
  decCoBorrower: {
    ethnicity: [
      '2',
      '1',
    ],
    race: [
      'American Indian or Alaska Native',
    ],
    sex: [
      'F',
    ],
    hasCitizenship: true,
    ethnicityHispanic: [
      'MEXICAN',
      'CUBAN',
      'OTHER',
    ],
    ethnicityOther: 'Guatamallean',
  },
  livingRentOrOwn: LivingSituation.OWN,
  loanAmount: 149999,
  loanPurpose: 'HELOC',
  mortgageBalance: 0,
  numberOfDependents: '3',
  citizenshipType: CitizenshipType.US_CITIZEN,
  schedulerEnabled: false,
  homeEquityLoanPurpose: 'Purchase Second Home',
  firstName: 'Benjamin',
  lastName: 'Prescott',
  middleName: 'Leopold-Julian',
  phone: '(313) 555-1212',
  email: 'lenderful@lenderful.com',
  dateOfBirth: '1996-12-11T05:00:00.000Z',
  hasCoBorrower: 'Yes',
  coBorrowerFirstName: 'Jacqueline',
  coBorrowerMiddleName: 'Caroline-Bryers',
  coBorrowerLastName: 'Prescott',
  coBorrowerEmail: 'lenderful@lenderful.com',
  coBorrowerDateOfBirth: '02-02-1999',
  coBorrowerCitizenshipType: CitizenshipType.US_CITIZEN,
  fico: '720',
  married: 'Married',
  propertyCity: 'Grosse Pointe Park',
  propertyState: 'MI',
  propertyZip: '48230',
  propertyStreet: '17145 Kercheval Ave',
  propertyStreet2: 'Breezeway Circle #1',
  propertyType: 'SFH',
  propertyUsage: 'PRI',
  propertyAppraisedValue: 5500000,
  maxLoanAmount: 150000,
  minLoanMet: 'Yes',
  livingYearTaxes: 8500,
  livingYearInsure: 14500,
  livingYearAssociate: 2000,
  hasAdditionalProperties: 'Yes',
  additionalProperties: [
    {
      propertyType: 'MOD',
      propertyUsage: 'INV',
      propertyAnnualRentAmount: 12000,
      propertyStreet: '1234 Main St.',
      propertyCity: 'Holland',
      propertyState: 'MI',
      propertyZip: '49423',
      propertyValue: 150000,
      propertyAnnualTaxAmount: 4000,
      propertyAnnualInsuranceAmount: 1000,
      propertyAnnualAssociationAmount: 250,
    },
    {
      propertyType: '24U',
      propertyUsage: 'INV',
      propertyAnnualRentAmount: 11000,
      propertyStreet: '2354 Madison Ave',
      propertyCity: 'Grand Rapids',
      propertyState: 'MI',
      propertyZip: '49507',
      propertyValue: 125000,
      propertyAnnualTaxAmount: 6000,
      propertyAnnualInsuranceAmount: 2000,
    },
    {
      propertyType: 'CON',
      propertyUsage: 'INV',
      propertyAnnualRentAmount: 16000,
      propertyStreet2: '',
      propertyCity: 'Kalamazoo',
      propertyState: 'MI',
      propertyValue: 75000,
      propertyAnnualInsuranceAmount: 600,
      propertyAnnualTaxAmount: 2400,
      propertyStreet: '5678 E Main St',
      propertyZip: '49048',
    },
    {
      propertyType: 'CON',
      propertyUsage: '2ND',
      propertyStreet2: '',
      propertyCity: 'Allegan',
      propertyState: 'MI',
      propertyValue: 125000,
      propertyAnnualInsuranceAmount: 600,
      propertyAnnualTaxAmount: 2400,
      propertyAnnualRentAmount: 12000,
      propertyStreet: '1234 N Main St',
      propertyZip: '49010',
    },
  ],
  employmentType: 'RET',
  retirementIncome: [
    {
      incomeSource: 'RET',
      incomeMonthly: 25100,
    },
    {
      incomeSource: 'SEC',
      incomeMonthly: 52100,
    },
    {
      incomeSource: 'AL',
      incomeMonthly: 200,
    },
    {
      incomeSource: 'CS',
      incomeMonthly: 350,
    },
  ],
  coBorrowerEmploymentType: 'EMP',
  coBorrowerEmployStreet: '401 Old St Jean St',
  coBorrowerEmployCity: 'Detroit',
  coBorrowerEmployCompanyName: 'Royal Transportation Co',
  coBorrowerEmployState: 'MI',
  coBorrowerEmployZip: '48214',
  coBorrowerEmployTitle: 'Owner',
  coBorrowerEmployStart: '2009-05-20T04:00:00.000Z',
  coBorrowerEmployBase: 14500,
  coBorrowerEmployOvertime: 900,
  coBorrowerEmployCommission: 891,
  coBorrowerEmployBonus: 2000,
  coBorrowerAdditionalIncome: [
    {
      incomeSource: 'SE',
      incomeMonthly: 1200,
    },
    {
      incomeSource: 'SEC',
      incomeMonthly: 1000,
    },
    {
      incomeSource: 'RET',
      incomeMonthly: 252,
    },
    {
      incomeSource: 'SS',
      incomeMonthly: 2222,
    },
    {
      incomeSource: 'CS',
      incomeMonthly: 900,
    },
    {
      incomeSource: 'AL',
      incomeMonthly: 850,
    },
    {
      incomeSource: 'RET',
      incomeMonthly: 1300,
    },
  ],
};

const james: any = {
  isTestCase: true,
  downPaymentDollar: 100000,
  downPaymentPercent: 37.7,
  escrowUsage: 'Yes',
  loanPurpose: 'PURCHASE',
  annualTaxes: 1050,
  annualInsurance: 1875,
  annualAssociation: 0,
  additionalIncome: [
    {
      incomeSource: 'SE',
      incomeMonthly: 2000,
    },
    {
      incomeSource: 'SEC',
      incomeMonthly: 3000,
    },
    {
      incomeSource: 'RET',
      incomeMonthly: 2345,
    },
    {
      incomeSource: 'SS',
      incomeMonthly: 5432,
    },
    {
      incomeSource: 'CS',
      incomeMonthly: 445,
    },
    {
      incomeSource: 'AL',
      incomeMonthly: 554,
    },
    {
      incomeSource: 'RET',
      incomeMonthly: 356,
    },
  ],
  decBorrower: {
    ethnicity: [
      'NO_SHARE',
    ],
    race: [
      'NO_SHARE',
    ],
    sex: [
      'NO_SHARE',
    ],
    hasCitizenship: true,
  },
  schedulerEnabled: false,
  firstName: 'James',
  lastName: 'Testcase',
  livingPropertyStreet: '171 Glenwood Dr',
  livingPropertyCity: 'Anthill',
  livingPropertyState: 'MO',
  livingPropertyZip: '65488',
  ssn: '000000012',
  hasCoBorrower: 'No',
  email: 'lenderful@lenderful.com',
  phone: '(313) 555-8888',
  dateOfBirth: '02-02-1990',
  buyingProcess: 'Shopping',
  purchaseTimeline: '3-6 Months',
  propertyAppraisedValue: 265000,
  propertyType: 'SFH',
  propertyUsage: 'PRI',
  propertyZip: '48315',
  married: 'Unmarried',
  veteranYN: 'No',
  employmentType: 'EMP',
  employCompanyName: 'ABC Warehouse',
  employBase: 8500,
  employOvertime: 50,
  employCommission: 25,
  employBonus: 100,
  incomeVerifiable: 'Yes',
  loanAmount: 165000,
  prequalAmount: 265000,
  prequalLetterAmount: 265000,
  prequalIssued: '2020-07-23T21:48:48.464Z',
  prequalExpiration: '2020-09-21T21:48:48.464Z',
};

const commercialEquipmentPrePopulateData: any = {
  commercialManagementList: [
    {
      managementFirstName: 'Tim',
      managementLastName: 'Griesemer',
      managementTitleHeld: 'Chief Technology Officer',
    },
  ],
  commercialOwnerList: [
    {
      ownerFirstName: 'Robert ',
      ownerLastName: 'Gardner',
      ownerMiddleName: 'T',
      ownerTitleHeld: 'CEO',
      race: [
        'NO_SHARE',
      ],
      ethnicity: [
        'NO_SHARE',
      ],
      sex: [
        'NO_SHARE',
      ],
      ownerPercentage: '51',
    },
  ],
  loanPurpose: 'PURCHASE',
  decBorrower: {
    ethnicity: [
      'NO_SHARE',
    ],
    race: [
      'NO_SHARE',
    ],
    sex: [
      'NO_SHARE',
    ],
    hasCitizenship: true,
    dec_commercial_bankrupt_flag: 'No',
    dec_commercial_credit_flag: 'No',
    dec_commercial_debt_flag: 'No',
    dec_commercial_legal_action_flag: 'No',
    dec_commercial_tax_due_flag: 'No',
  },
  excludedQuestions: [],
  commercialExpectedCost: 100000,
  commercialDescription: 'Computer Infrastructure',
  downPaymentDollar: 10000,
  commercialBusinessNeed: 'Expanded Server Room',
  commercialLifeExpectancy: '7',
  commercialLoanTiming: '1-3 Months',
  commercialBusinessName: 'Lenderful LLC',
  commercialDBA: 'Lenderful Solutions',
  commercialCensusTract: '153200',
  commercialNAICSCode: '541511',
  commercialStreet: '235 Pierce',
  commercialCity: 'Birmingham',
  commercialState: 'MI',
  commercialZip: '48009',
  commercialPhone: '(248) 686-0900',
  commercialEmployeeCount: '5',
  commercialWebsite: 'lenderfulsolustions.com',
  commercialEntityType: 'LLC',
  commercialBusinessType: 'Service',
  commercialStateOfIncorporation: 'MI',
  commercialYearStarted: '2017',
  commercialRevenueTrend3: 'Increasing',
  commercialRevenueLastYear: 5000000,
  commercialRevenueExplanation: 'Many new bank customers',
  commercialProfitTrend3: 'Increasing',
  commercialProfitExplanation: 'High margin business',
  commercialCollateralList: 'Buildings (2), Vehicles(5), Computer Equipment',
  commercialBusinessOwnershipType:'Minority',
  employmentType: 'EMP',
  commercialEmploySameBusiness: 'Yes',
  employTitle: 'CEO',
  employPhone: '(248) 555-1212',
  employStart: '2016-03-15T05:00:00.000Z',
  employBase: 5000,
  hasOtherManagement: 'Yes',
};

const options = [
  { label: 'No Test Case Selected', value: {} },
  { label: 'Commercial Equipment ', value: commercialEquipmentPrePopulateData },
  { label: 'Rusty - Purchase Application', value: rusty },
  { label: 'Nancy - Refinance Application', value: nancy },
  { label: 'Paul - HELOC', value: paul },
  { label: 'Benjamin - Home Equity', value: benjamin },
  { label: 'James - Prequal', value: james },
];

class DevTestBorrowers extends React.Component<any, any> {
  state = {
    anchorEl     : null,
    selectedIndex: 0,
  };

  handleClickListItem = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, anchorEl: null });
    this.props.setCreditPullTestCase(options[index].value);
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <React.Fragment>
        <ListItem
          button
          aria-haspopup = 'true'
          aria-controls = 'lock-menu'
          aria-label    = 'Borrower Test Cases'
          onClick       = {this.handleClickListItem}
        >
          <ListItemText
            primary   = 'Borrower Test Cases'
            secondary = {options[this.state.selectedIndex].label}
          />
        </ListItem>
        <Menu
          id       = 'lock-menu'
          anchorEl = {anchorEl}
          open     = {Boolean(anchorEl)}
          onClose  = {this.handleClose}
        >
          {options.map((option, index) => {
            return (
              <MenuItem
                disabled = {index === 0}
                key      = {option.label}
                onClick  = {event => this.handleMenuItemClick(event, index)}
                selected = {index === this.state.selectedIndex}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </Menu>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = DevToolActions;

export default connect(
  null,
  mapDispatchToProps,
)(DevTestBorrowers);
